module.exports = __webpack_public_path__ + "static/media/multiplex15.e20e3f72.png";